import { render, staticRenderFns } from "./DesktopHeader.vue?vue&type=template&id=5c07e2ab&scoped=true&"
import script from "./DesktopHeader.vue?vue&type=script&lang=ts&"
export * from "./DesktopHeader.vue?vue&type=script&lang=ts&"
import style0 from "./DesktopHeader.vue?vue&type=style&index=0&id=5c07e2ab&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c07e2ab",
  null
  
)

export default component.exports